function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './ListingOffersAndDeals.css';
import React, { useContext, useState, useMemo, useEffect, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import FiltersMobileSwitchPanel from './components/FiltersMobileSwitchPanel';
import CurrencySelector from './components/CurrencySelector';
import DropDownMultiselect from './components/DropDownMultiselect';
import OfferAndDealDatePicker from './components/OfferAndDealDatePicker';
import Sorting from './components/Sorting';
import FiltersSelected from './components/FiltersSelected';
import OfferAndDealSearch from './components/OfferAndDealSearch';
import OfferAndDeal from './components/OfferAndDeal';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { getColorByTheme, getPageThemeColors, get, hexToRgb, canUseDOM, getDictionaryItem, replaceUrlPluses } from '../../utils';
import { qsToObject } from '../../utils/querystring';
import getListing from '../../utils/getListing';
import Loader from '../atoms/Loader/Loader';
import { splitter, generateFacetForRequest, addQueryStringMultiple } from '../Listing/index';
import { commonStyles as headerStyle } from '../57_HeaderListingPage/HeaderListingPage';
import { ReactComponent as IconGrid } from '../../resources/icons/layout-grid.svg';
import { ReactComponent as IconList } from '../../resources/icons/layout-list.svg';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { isShowRuleIsHide } from '../atoms/BlurCard/BlurCard';
import { checkJssError } from '../../utils/checkJssError';
import throttle from 'lodash/throttle';
import useProfile from '../../utils/hooks/useProfile';
import { DATE_RANGE_FACET_NAME, LOCAL_STORAGE_APP_CURRENCY, SORT_QUERY_NAME, TAGS_FOR_PREDEFINED_FACET_NAME, TEXT_SEARCH_FACET_NAME } from './constants';
const getFacetNamesValue = filterData => {
  if (filterData && filterData.values) {
    const values = filterData.values.map(filter => {
      const item1 = get(filter, 'fieldNameItem.item.fieldName.value');
      const item2 = get(filter, 'fieldNameItems.items.0.fieldName.value');
      const facet = item1 || item2 || DATE_RANGE_FACET_NAME;
      return facet;
    });
    return values;
  } else {
    return [];
  }
};
export const stateTofacetsObj = filterState => {
  return Object.keys(filterState).reduce((acc, item) => {
    const currentFacetName = filterState[item].facetName;
    const currentValues = filterState[item].value;
    return _objectSpread(_objectSpread({}, acc), {}, {
      [currentFacetName]: acc[currentFacetName] ? [...acc[currentFacetName], ...currentValues] : currentValues
    });
  }, {});
};
const getDefaultSortValue = location => canUseDOM ? qsToObject(location.search)[SORT_QUERY_NAME] || '' : '';
const getDefaultSearchValue = location => canUseDOM ? replaceUrlPluses(qsToObject(location.search)[TEXT_SEARCH_FACET_NAME]) || '' : '';
const createFilterState = (filtersList, location, history) => {
  const qsValues = canUseDOM ? qsToObject(location.search) : {};
  const state = {};
  if (filtersList && filtersList.length) {
    filtersList.forEach(filterItem => {
      const fieldName = filterItem.name;
      const fieldTitle = get(filterItem, 'title.jss.value') || filterItem.name;
      const filterTemplate = get(filterItem, 'fieldTypeItem.item.fieldType.value');
      const facetName = get(filterItem, 'fieldNameItem.item.fieldName.value') || DATE_RANGE_FACET_NAME;
      const preselectedTagsValues = get(filterItem, 'preselectedTags.values', []) || [];
      let preselectedTags = [];
      let listOfTags = [];
      if (filterItem.tagsToDisplay && filterItem.tagsToDisplay.values && filterItem.tagsToDisplay.values.length) {
        listOfTags = filterItem.tagsToDisplay.values.map(tag => get(tag, 'title.value') || get(tag, 'title.name'));
      }
      const preselectedFromQS = qsValues[facetName] ? qsValues[facetName].split(splitter).map(value => replaceUrlPluses(value)).filter(value => listOfTags.includes(value)) : [];
      const preselectedNoDublicates = [...new Set([...preselectedFromQS])];
      if (preselectedTagsValues.length) {
        preselectedTags = preselectedTagsValues.map(p => get(p, 'title.value'));
        const selected = {};
        preselectedTags.forEach(key => {
          selected[key] = true;
        });
        addQueryStringMultiple(facetName, selected, history);
      }
      const mergedValue = [...new Set([...preselectedNoDublicates, ...preselectedTags])];
      const fieldState = {
        title: fieldTitle,
        facetName: facetName,
        filterTemplate,
        value: mergedValue || []
      };
      if (facetName === DATE_RANGE_FACET_NAME) {
        fieldState.valueReadableString = '';
        fieldState.visible = false;
        fieldState.value = replaceUrlPluses(qsValues[facetName]) || '';
      }
      state[fieldName] = fieldState;
    });
  }
  return state;
};
const ListingOffersAndDealsComponent = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const location = useLocation();
  const history = useHistory();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  const userProfile = useProfile();
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const dictionary = get(fields, 'data.dictionary');
  const title = get(fields, 'data.listingConfiguration.title');
  const introText = get(fields, 'data.listingConfiguration.introText');
  const secondaryIntroText = get(fields, 'data.listingConfiguration.searchText.jss.value');
  const sortField = get(fields, 'data.listingConfiguration.sorting.sortPrefixes') || [];
  const socialSharing = get(fields, 'data.socialSharing');
  const currencies = get(fields, 'data.listingConfiguration.currencies.currencies', []);
  const countryItems = get(fields, 'data.countries.countryValues') || [];

  /* Filtering vals*/
  const filterData = get(fields, 'data.listingConfiguration.filters', []);
  const typeArray = get(fields, 'data.listingConfiguration.contentType.types') || [];
  const pagesize = Number(get(fields, 'data.listingConfiguration.pageSize.jss.value') || 1);
  const mostSearchedValues = getDictionaryItem(dictionary, 'mostSearchedValues') || '';

  /* Generate list of original predefined categories */
  const predefinedFilters = useMemo(() => {
    if (filterData.values && filterData.values.length) {
      const filtersForPredefine = filterData.values.filter(jssFilter => (get(jssFilter, 'fieldNameItem.item.fieldName.value') === TAGS_FOR_PREDEFINED_FACET_NAME && get(jssFilter, 'preselectedTags.values') || []).length).map(predefineItem => get(predefineItem, 'preselectedTags.values'));
      const arrayOfVals = filtersForPredefine.reduce((acc, item) => {
        return [...acc, ...item.map(predefinedValue => get(predefinedValue, 'title.value'))];
      }, []);
      return [...new Set([...arrayOfVals])].map(tagValue => `${TAGS_FOR_PREDEFINED_FACET_NAME}:${tagValue}`);
    }
    return [];
  }, [filterData]);
  const [gridMode, setGridMode] = useState(true);
  const [isVdsite, setIsVdsite] = useState(true);
  const [currencyIndex, setCurrencyIndex] = useState(1);
  const [currencyName, setCurrencyName] = useState('AED');
  const [filtersMobileItemsVisible, setFiltersMobileItemsVisible] = useState(false);
  const [sortingValue, setSortingValue] = useState(() => getDefaultSortValue(location));
  const [searchTextValue, setSearchTextValue] = useState(() => getDefaultSearchValue(location));
  const [filterState, setFilterState] = useState(() => createFilterState(filterData.values.filter(settings => get(settings, 'fieldNameItem.item.fieldName.value') !== TAGS_FOR_PREDEFINED_FACET_NAME), location, history));
  const [filterFiledOpened, setFilterFiledOpened] = useState('');

  /* Filtering states*/
  const [hits, setHits] = useState([]);
  const [page, setpage] = useState(0);
  const [result, setResult] = useState();
  const [facets, setFacets] = useState({});
  const [loading, setLoading] = useState(false);
  const [nbHits, setNbHits] = useState(0);
  const [setFilters, applySetFilters] = useState(true);
  const [buttonPressed, setButtonPressed] = useState(false);
  const [clearAllFilters, setClearAllFilters] = useState(false);

  /* Dictionary terms */
  const clearAllText = getDictionaryItem(dictionary, 'clearAll') || '';
  const clearText = getDictionaryItem(dictionary, 'clear') || '';
  const viewedAmountText = getDictionaryItem(dictionary, 'viewedAmount') || '';
  const loadMoreText = getDictionaryItem(dictionary, 'loadMore') || '';
  const fromText = getDictionaryItem(dictionary, 'from') || '';
  const offText = getDictionaryItem(dictionary, 'off') || '';
  const expiresSoonText = getDictionaryItem(dictionary, 'expiresSoon') || '';
  const moreInfoText = getDictionaryItem(dictionary, 'moreInfo') || '';
  const bookNowText = getDictionaryItem(dictionary, 'bookNow') || '';
  const readMoreText = getDictionaryItem(dictionary, 'readMore') || '';
  const readLessText = getDictionaryItem(dictionary, 'readLess') || '';
  const filtersTitleText = getDictionaryItem(dictionary, 'filtersTitle') || '';
  const autocompletePlaceholderText = getDictionaryItem(dictionary, 'autocompletePlaceholder') || '';
  const resultsTitleText = getDictionaryItem(dictionary, 'resultsTitle') || '';
  const resultsForText = getDictionaryItem(dictionary, 'resultsFor') || '';
  const filtersMobileLabelText = getDictionaryItem(dictionary, 'filtersMobileLabel') || '';
  const showResultsText = getDictionaryItem(dictionary, 'showResults') || '';
  const sortFieldDeskLabelText = getDictionaryItem(dictionary, 'sortFieldDeskLabel') || '';
  const sortFieldMobileLabelText = getDictionaryItem(dictionary, 'Sort') || '';
  const termsAndConditionsText = getDictionaryItem(dictionary, 'termsAndConditions') || '';
  const emptySearchText = getDictionaryItem(dictionary, 'emptySearch') || '';
  const ratingTextStar = getDictionaryItem(dictionary, 'star') || '';
  const ratingTextStars = getDictionaryItem(dictionary, 'stars') || '';
  const carouselWrapperRef = useRef(null);
  const [titleHeight, setTitleHeight] = useState(0);
  const [websiteHeight, setWebsiteHeight] = useState(0);
  useEffect(() => {
    const lsCurrency = localStorage.getItem(LOCAL_STORAGE_APP_CURRENCY);
    setCurrencyName(lsCurrency || 'AED');
  }, []);
  useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);

  /* Params elements */
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  /* End Params elements */

  const variables = BackgroundColorHex ? {
    '--listing-deals-background-color': BackgroundColorHex,
    '--listing-deals-background-color-rgb': hexToRgb(BackgroundColorHex, true),
    '--listing-deals-background-active-color': ActiveColorHex,
    '--listing-deals-color': ColorHex
  } : {
    '--listing-deals-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--listing-deals-background-color-rgb': hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
    '--listing-deals-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--listing-deals-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  const queryParams = canUseDOM ? qsToObject(location.search) : {};
  if (Object.keys(queryParams).length !== 0) {
    for (let key in queryParams) {
      queryParams[key] = replaceUrlPluses(queryParams[key], key === 'tags' || key === 'itineraryDatesRange') || queryParams[key];
    }
  }
  const setListingFilter = () => {
    setpage(0);
    setHits([]);
    applySetFilters(true);
  };
  const loadMore = () => {
    if (canUseDOM) {
      window.onscroll = () => {
        window.scrollTo(window.scrollX, window.scrollY);
      };
    }
    setButtonPressed(true);
    applySetFilters(true);
    setpage(prevState => prevState + 1);
    if (eventsAnalytics['loadMoreAnalytics']) {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['loadMoreAnalytics'], params));
    }
  };
  const renderResultsText = () => {
    const loadedHits = (page + 1) * pagesize;
    return viewedAmountText.replace('{x}', String(loadedHits > nbHits ? nbHits : loadedHits)).replace('{y}', String(nbHits));
  };
  const resetAndSubmitFilters = () => {
    const newState = _objectSpread({}, filterState);
    Object.keys(newState).forEach(filterName => {
      if (newState[filterName].facetName === DATE_RANGE_FACET_NAME) {
        newState[filterName].valueReadableString = '';
        newState[filterName].value = '';
      } else {
        newState[filterName].value = [];
      }
    });
    const finalQSObject = stateTofacetsObj(newState);
    const url = new URL(window.location.href);
    Object.keys(finalQSObject).forEach(facet => {
      url.searchParams.delete(facet);
    });
    history.replace(`${history.location.pathname}${url.search}${url.hash}`);
    setFilterState(newState);
    setListingFilter();
  };
  let countHeights;
  if (canUseDOM) {
    countHeights = throttle(() => {
      if (carouselWrapperRef.current) {
        let titleHeight = 0,
          websiteHeight = 0;
        const titlesList = carouselWrapperRef.current.querySelectorAll('.deal__header--interactive');
        titlesList.forEach(title => {
          const height = title.offsetHeight;
          if (titleHeight < height) titleHeight = height;
        });
        const websitelinkList = carouselWrapperRef.current.querySelectorAll('.deal__details-top-contacts');
        const hasChildren = Array.from(websitelinkList).some(element => {
          return element.children.length > 0;
        });
        if (hasChildren) websiteHeight = 42;
        setTitleHeight(titleHeight);
        setWebsiteHeight(websiteHeight);
      }
    }, 300);
  }
  useEffect(() => {
    if (canUseDOM) {
      setTimeout(countHeights, 500);
      window.addEventListener('resize', countHeights);
    }
    return () => {
      window.removeEventListener('resize', countHeights);
    };
  }, []);
  useEffect(() => {
    setTimeout(countHeights, 500);
  }, [sitecoreContext.selectedFontSize, facets]);
  useEffect(() => {
    const algoliaIndexes = sortingValue ? `${get(params, 'SearchIndex')}_${sortingValue}` : get(params, 'SearchIndex');
    let tag = 'tags:';
    if (canUseDOM) {
      const hash = window.location.hash;
      const hashvalue = hash.split('#tag=');
      if (hashvalue[1]) {
        tag = 'tags:' + decodeURI(hashvalue[1]);
      }
    }
    let types = typeArray.map(type => {
      let value = type && type.template.targetItem.value;
      return `type:${value}`;
    });
    const facetNames = [...new Set([...getFacetNamesValue(filterData)])];
    let filters;
    const dateRangeStateName = Object.keys(filterState).find(name => filterState[name].facetName === DATE_RANGE_FACET_NAME);
    if (dateRangeStateName && filterState[dateRangeStateName].value) {
      filters = filterState[dateRangeStateName].value;
    }
    const objOfFacets = stateTofacetsObj(filterState);
    const filterParams = generateFacetForRequest(objOfFacets, filterData, [TAGS_FOR_PREDEFINED_FACET_NAME]);
    const itemFilters = {
      query: searchTextValue,
      filters,
      facets: [...facetNames],
      facetFilters: [[...types], [...predefinedFilters], ...filterParams, [tag]],
      hitsPerPage: pagesize,
      page: page
    };
    const listingRequest = () => {
      setLoading(true);
      getListing(algoliaIndexes, itemFilters, algoliaSettings).then(response => {
        setFacets(response.facets);
        setResult(response);
        applySetFilters(false);
        setClearAllFilters(false);
        setNbHits(response.nbHits);
        if (response.hits.length) {
          if (buttonPressed) {
            setButtonPressed(false);
            const resultsBlocks = document.querySelectorAll('.deals-grid');
            if (resultsBlocks.length) {
              const lastResultsBlock = resultsBlocks[resultsBlocks.length - 1];
              const focusableList = lastResultsBlock.querySelectorAll('a, button, [tabindex="0"]');
              if (focusableList.length) {
                const lastFocusable = focusableList[focusableList.length - 1];
                lastFocusable.focus();
              }
            }
          }
          setHits(page === 0 ? response.hits : hits.concat(response.hits));
        }
        setTimeout(function () {
          if (canUseDOM) {
            window.onscroll = () => {};
          }
        }, 100);
        setLoading(false);
      });
    };
    if (setFilters) {
      listingRequest();
    }
  }, [setFilters, page, buttonPressed]);
  const togglePanelHandler = close => {
    setFiltersMobileItemsVisible(close === false ? close : !filtersMobileItemsVisible);
    if (close !== false && document.body.style.overflowY === '') {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = '';
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    ref: carouselWrapperRef,
    style: {
      '--titles-height': titleHeight,
      '--websiteLinks-height': websiteHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--secondary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-xl-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headerSelectWrapper clearfix"
  }, !!currencies.length && /*#__PURE__*/React.createElement("div", {
    className: "selectorFloat"
  }, /*#__PURE__*/React.createElement(CurrencySelector, {
    changeCurrency: setCurrencyIndex,
    changeCurrencyName: setCurrencyName,
    currencyName: currencyName,
    currencies: currencies,
    rtl: rtl,
    themeVariables: variables
  })), /*#__PURE__*/React.createElement("div", {
    className: "header__title"
  }, title && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: title.jss,
    className: "h2 c-title__text textWordBreak"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-8"
  }, introText && /*#__PURE__*/React.createElement(Text, {
    className: "p header__content",
    tag: "p",
    field: introText.jss
  }))))))), secondaryIntroText && /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-8"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: secondaryIntroText
    }
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters__search"
  }, /*#__PURE__*/React.createElement("div", {
    className: " row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-9 col-xl-10"
  }, /*#__PURE__*/React.createElement(OfferAndDealSearch, {
    rtl: rtl,
    searchValue: searchTextValue,
    setSearchValue: setSearchTextValue,
    placeholder: autocompletePlaceholderText,
    resultsTitle: resultsTitleText,
    resultsForText: resultsForText,
    setListingFilter: setListingFilter,
    mostSearchedValues: mostSearchedValues ? mostSearchedValues.split('|').map(term => term.trim()) : [],
    resultsNumber: nbHits,
    eventsAnalytics: eventsAnalytics,
    params: params
  })))), filtersTitleText && /*#__PURE__*/React.createElement("h5", {
    className: "filters__header"
  }, filtersTitleText), /*#__PURE__*/React.createElement("div", {
    className: "filters__grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-6 col-lg-9 col-xl-10"
  }, /*#__PURE__*/React.createElement(FiltersMobileSwitchPanel, {
    filterState: filterState,
    emptyFilterState: "",
    labelText: filtersMobileLabelText,
    clearAll: clearAllText,
    ctaText: showResultsText,
    togglePanel: togglePanelHandler,
    panelVisible: filtersMobileItemsVisible,
    clearFilter: () => {
      togglePanelHandler();
      resetAndSubmitFilters();
    },
    triggerFilterFieldOpen: setFilterFiledOpened
  }), /*#__PURE__*/React.createElement("div", {
    className: "filters__desk-layout-wrapper"
  }, !!(filterData.values && filterData.values.length) && /*#__PURE__*/React.createElement("div", {
    className: "filters__desk-layout"
  }, filterData.values.filter(settings => get(settings, 'fieldNameItem.item.fieldName.value') !== TAGS_FOR_PREDEFINED_FACET_NAME).map(singleFilter => {
    const filterTemplate = get(singleFilter, 'fieldTypeItem.item.fieldType.value');
    const facetName = get(singleFilter, 'fieldNameItem.item.fieldName.value');
    if (filterTemplate === 'Dropdown Multi Select') {
      const preselectedTags = get(singleFilter, 'preselectedTags.values', []).map(p => get(p, 'title.value'));
      const fieldName = get(singleFilter, 'name');
      const value = filterState[fieldName] === undefined ? preselectedTags : [...filterState[fieldName].value];
      return /*#__PURE__*/React.createElement("div", {
        className: "filters__desk-item",
        key: fieldName
      }, /*#__PURE__*/React.createElement(DropDownMultiselect, {
        filter: singleFilter,
        algoliaResponcedFacetValues: facets[facetName],
        closeMobileOpener: () => togglePanelHandler(false),
        setValue: newValue => {
          setFilterState(_objectSpread(_objectSpread({}, filterState), {}, {
            [fieldName]: _objectSpread(_objectSpread({}, filterState[fieldName]), newValue)
          }));
          applySetFilters(true);
        },
        value: value,
        preselectedTags: preselectedTags,
        clearText: clearText,
        ctaText: showResultsText,
        setListingFilter: setListingFilter,
        externalVisible: filterFiledOpened,
        setExternalVisible: setFilterFiledOpened,
        eventsAnalytics: eventsAnalytics,
        params: params,
        clearAllFilters: clearAllFilters
      }));
    }
    if (filterTemplate === 'Date Range') {
      const fieldName = get(singleFilter, 'name');
      return /*#__PURE__*/React.createElement("div", {
        className: "filters__desk-item",
        key: fieldName
      }, /*#__PURE__*/React.createElement(OfferAndDealDatePicker, {
        filter: singleFilter,
        closeMobileOpener: () => togglePanelHandler(false),
        setValue: newValue => {
          setFilterState(_objectSpread(_objectSpread({}, filterState), {}, {
            [fieldName]: _objectSpread(_objectSpread({}, filterState[fieldName]), newValue)
          }));
        },
        submitedValue: submitedValue => {
          submitedValue && tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['selectDatesAnalytics'], params), `${submitedValue.valueReadableString}`);
        },
        valueReadableString: filterState[fieldName].valueReadableString,
        value: filterState[fieldName].value,
        clearText: clearText,
        ctaText: showResultsText,
        setListingFilter: setListingFilter,
        externalVisible: filterFiledOpened,
        setExternalVisible: setFilterFiledOpened
      }));
    }
    return null;
  })), /*#__PURE__*/React.createElement("div", {
    className: "filters__mode-selector d-none d-lg-block"
  }, /*#__PURE__*/React.createElement("menu", {
    className: "mode-selector"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "Grid view",
    className: `${gridMode ? 'active' : ''}`,
    onClick: () => {
      if (!gridMode) setGridMode(true);
    }
  }, /*#__PURE__*/React.createElement(IconGrid, null)), /*#__PURE__*/React.createElement("button", {
    "aria-label": "List view",
    className: `${gridMode ? '' : 'active'}`,
    onClick: () => {
      if (gridMode) setGridMode(false);
    }
  }, /*#__PURE__*/React.createElement(IconList, null)))))), /*#__PURE__*/React.createElement("div", {
    className: "col-6 col-lg-3 col-xl-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters__sort"
  }, /*#__PURE__*/React.createElement(Sorting, {
    values: sortField,
    deskLabelText: sortFieldDeskLabelText,
    mobileLabelText: sortFieldMobileLabelText,
    defaultSortValue: '',
    value: sortingValue,
    setSort: newValue => {
      setSortingValue(newValue);
    },
    clearText: clearText
    /* ctaText={showResultsText} */,
    setListingFilter: setListingFilter,
    eventsAnalytics: eventsAnalytics,
    params: params
  }))))), /*#__PURE__*/React.createElement(FiltersSelected, {
    filterState: filterState,
    setFilter: newValue => {
      setFilterState(_objectSpread(_objectSpread({}, filterState), newValue));
    },
    resetFilters: newValue => {
      filterData && filterData.values.filter(settings => get(settings, 'fieldNameItem.item.fieldName.value') !== TAGS_FOR_PREDEFINED_FACET_NAME).map(el => {
        const facetName = get(el, 'fieldNameItem.item.fieldName.value');
        let preselectedTags = null;
        if (el.preselectedTags) {
          preselectedTags = get(el, 'preselectedTags.values', []).map(tag => get(tag, 'title.value', get(tag, 'name')));
          if (newValue[el.name]) {
            newValue[el.name].value = preselectedTags;
          } else {
            newValue[el.name] = {
              value: preselectedTags
            };
          }
          const selected = {};
          preselectedTags.forEach(key => {
            selected[key] = true;
          });
          addQueryStringMultiple(facetName, selected, history);
        }
      });
      setFilterState(newValue);
      setClearAllFilters(true);
    },
    clearText: clearAllText,
    setListingFilter: setListingFilter,
    facets: facets,
    resetAndSubmitFilters: resetAndSubmitFilters,
    eventsAnalytics: eventsAnalytics,
    params: params
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, !loading && !hits.length && /*#__PURE__*/React.createElement("h4", {
    className: "empty-results",
    dangerouslySetInnerHTML: {
      __html: emptySearchText
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: `row deals-grid ${gridMode ? '' : 'deals-grid--list'} `
  }, hits.map(deal => {
    return /*#__PURE__*/React.createElement("div", {
      key: deal.objectID,
      className: `col-lg-3 ${isShowRuleIsHide(deal) ? 'd-flex' : ''}`
    }, /*#__PURE__*/React.createElement(OfferAndDeal, {
      userProfile: userProfile,
      textToHighlight: searchTextValue,
      fromText: fromText,
      offText: offText,
      expiresSoonText: expiresSoonText,
      moreInfoText: moreInfoText,
      bookNowText: bookNowText,
      readMoreText: readMoreText,
      readLessText: readLessText,
      termsAndConditionsText: termsAndConditionsText,
      deal: deal,
      rtl: rtl,
      currency: currencyName,
      currencyIndex: currencyIndex,
      gridMode: gridMode,
      socialSharing: socialSharing,
      themeVariables: variables,
      eventsAnalytics: eventsAnalytics,
      params: params,
      ratingTextStars: ratingTextStars,
      ratingTextStar: ratingTextStar,
      countryItems: countryItems
    }));
  })))), loading && /*#__PURE__*/React.createElement(Loader, {
    color: BackgroundColorHex || primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary
  }), result && result.nbPages - 1 > result.page && /*#__PURE__*/React.createElement("div", {
    className: "deals-bottom-panel"
  }, /*#__PURE__*/React.createElement("p", {
    className: "deals-bottom-panel__amount"
  }, renderResultsText()), /*#__PURE__*/React.createElement("button", {
    onClick: loadMore,
    className: "btn btn-secondary deals-bottom-panel__load-more"
  }, loadMoreText)), /*#__PURE__*/React.createElement("pre", {
    className: "d-none"
  }, /*#__PURE__*/React.createElement("div", null, JSON.stringify(filterState, null, 2)), /*#__PURE__*/React.createElement("div", null, `Sorting: ${sortingValue}`), /*#__PURE__*/React.createElement("div", null, `Search submitted text: ${searchTextValue}`)))))));
};
const ListingOffersAndDeals = props => checkJssError(props, ListingOffersAndDealsComponent, props.fields.data.listingConfiguration);
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${headerStyle} ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "ci72z0l";
const ltrStyles = "lg4cb2d";
const rtlStyles = "r52qsxw";
export default ListingOffersAndDeals;